import { DataForm, FieldProps } from 'components';
import { Drawers } from 'app/types/drawer';
import { useSelector } from 'react-redux';
import { selectors } from 'app/services/projects';
import { Skeleton } from 'antd';
import { useLinkToolToProjectMutation } from 'app/services/tools';
import ScannerModal from 'components/DataForm/components/ScannerModal';
import { useGetToolsForProject } from 'hooks/useGetToolsForProject';
import { parseQrValue } from 'utils/qr/parseQrValue';

const AddTool = () => {
  const project = useSelector(selectors.getProject);

  const { field, isLoading, isFetching, scannerSearchCallback } = useGetToolsForProject({ projectId: project?.Id, required: true });
  const [ linkToolToProject, meta ] = useLinkToolToProjectMutation();

  if (!project || isLoading || isFetching) return <Skeleton active />;

  const fields: FieldProps[] = [
    {
      ...field,
      addOn: (
        <ScannerModal
          searchCallBack={scannerSearchCallback}
          transformValue={(scanned) => parseQrValue(scanned).barcodeValue}
          local
          multiple
        />
      ),
    }
  ];

  const handleSubmit = async (values: any) => {
    await linkToolToProject({ projectId: project?.Id, body: values });
  };

  return <>
    <DataForm
      id={Drawers.ADD_PROJECT_TOOL}
      entity="projecttool"
      onSubmit={handleSubmit}
      fields={fields}
      meta={meta}
    />
  </>;
};

export default AddTool;
